import React from 'react';
import { useTranslation } from '@/store/languageStore';
import { WrenchScrewdriverIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { PageBackButton } from '@/components/common/PageBackButton';

interface ComingSoonProps {
  title: string;
  description?: string;
  features?: string[];
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description, features }) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 bg-bgContainer h-full">
      <div className="flex items-center gap-3 mb-6">
        <PageBackButton />
        <h1 className="text-2xl font-bold text-textDefault flex items-center gap-2">
          <UserGroupIcon className="w-6 h-6 text-primary" />
          {title}
        </h1>
      </div>
      <div className="flex items-center justify-center min-h-[calc(100%-80px)]">
        <div className="max-w-lg w-full">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-6 bg-bgPrimary/10 rounded-full flex items-center justify-center">
              <WrenchScrewdriverIcon className="w-10 h-10 text-bgPrimary" />
            </div>
            <p className="text-textSecondary mb-2">
              {description || t('common.comingSoon') || 'Kommer snart'}
            </p>
            <p className="text-sm text-textTertiary">
              {t('common.underDevelopment') || 'Denna funktion är under utveckling'}
            </p>
          </div>
          {features && features.length > 0 && (
            <div className="bg-bgElevated rounded-xl border border-border p-6 text-left">
              <h2 className="text-lg font-semibold text-textDefault mb-4">
                {t('common.plannedFeatures') || 'Planerade funktioner'}
              </h2>
              <ul className="space-y-3">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="p-1 bg-primary/10 rounded-full mt-0.5 shrink-0">
                      <svg className="w-3 h-3 text-primary" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-sm text-textSecondary">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;

